'use client'

import Image from 'next/image'
import { useRef, useState } from 'react'

import { useMountEffect } from '@/hooks/useMountEffect'

import './wafflr.css'

// Scroll speed, in px per ms, that sends the waffle ducking.
const DUCK_SPEED = 1.6

// The waffle from the June 2025 icon, holding on to the top of the hero video.
// Scroll fast and it ducks behind the edge, then pops back up.
export function PeekingWaffle() {
  const [ducked, setDucked] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)

  useMountEffect(() => {
    let lastY = window.scrollY
    let lastT = performance.now()
    const onScroll = () => {
      const now = performance.now()
      const speed = Math.abs(window.scrollY - lastY) / Math.max(now - lastT, 1)
      lastY = window.scrollY
      lastT = now
      if (speed <= DUCK_SPEED) return
      setDucked(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setDucked(false), 650)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      clearTimeout(timer.current)
    }
  })

  return (
    <div className="wf-peek-wrap">
      <Image
        className="wf-peek"
        data-ducked={ducked || undefined}
        src="/images/projects/wafflr/story/peek.webp"
        alt="The Wafflr waffle, peeking over the edge"
        width={400}
        height={265}
        unoptimized
        priority
      />
    </div>
  )
}
